import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgRelaxGlyphSecondary from './svgs/RelaxGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var relaxGlyph = (props => useIcon(null, SvgRelaxGlyphSecondary, props));

export { relaxGlyph as default };
